angular.module('kareo.ui.shared.directives.choose-document', [
  'flow',
  'angularUtils.directives.dirPagination',
  'pikaday',
  'kareo.ui.shared.directives.choose-document.reference-services'])
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put('templates/choose-document-dialog/choose-document-dialog.html', require('./choose-document-dialog.pug')());
    $templateCache.put('choose-document-dialog/choose-document-pagination.html', require('./choose-document-pagination.pug')());
  }])
  /**
   * Additional providers required:
   *
   * close: function to call when closing modal
   * config: {
 *  references: previous attachment references -- used for de-dupe validation in modal (you can't attach twice)
 * }
   */
  .controller('ChooseDocumentCtrl', [
    '$rootScope',
    '$scope',
    'close',
    'AttachmentDocumentService',
    '$timeout',
    'config',
    function ($rootScope, $scope, close, AttachmentDocumentService, $timeout, config) {
      $scope.attachState = 'choose';
      config = config || {};

      $scope.attachButtonLabel = config.attachButtonLabel || 'Attach';
      $scope.uploadButtonLabel = config.uploadButtonLabel || 'Upload and Attach';

      $scope.documentData = {
        documentStatus: 1, documentDate: moment().format('YYYY-MM-DD'), comment: '', fileName: '', documentName: ''
      };
      $scope.pagination = {
        current: 1
      };
      $scope.searchData = {
        searching: false, queryValue: ''
      };
      $scope.documentLabels = undefined;
      $scope.documentLabelLookup = {};
      AttachmentDocumentService.getDocumentLabels().then((labels) => {
        $scope.documentLabels = labels;
        for (var i = 0; i < labels.length; i++) {
          $scope.documentLabelLookup[labels[i].key] = labels[i].value;
        }
      });
      // this is required for updating page number to 1, when searching
      $scope.$watch('pagination.current', (val) => {
        $scope.pageChanged(val);
      });
      $scope.pageChanged = function (pageNum) {
        AttachmentDocumentService.getDocuments(pageNum, $scope.searchData.queryValue).then((response) => {
          $scope.documentList = response.dataList;
          $scope.totalDocuments = response.totalRecords;
        });
      };
      var requestSent;
      $scope.searchDocuments = function () {
        $scope.searchData.searching = true;
        if (!requestSent) {
          requestSent = $timeout(() => {
            requestSent = null;
            if ($scope.pagination.current === 1) {
              $scope.pageChanged(1);
            } else {
              $scope.pagination.current = 1;
            }
          }, 100);
        }
      };
      function onFileError() {
        $scope.uploadState = 'error';
      }

      $rootScope.flowConfiguration = {
        flow: '', onSuccess($message) {
          return $scope.close(angular.fromJson($message));
        }, onFileError, onFileLoad(event) {
          $scope.uploadState = 'uploading';
          if (['EXE', 'APP', 'VB', 'SCR', 'MSI'].indexOf(event.getExtension().toUpperCase()) > -1) {
            return onFileError();
          }
          var file = event.file;
          if (file.size > 1024 * 1024 * 10) {
            return onFileError();
          }
          $scope.documentData.fileName = event.name;
          $scope.flowConfiguration.flow = event.flowObj;
          $scope.attachState = 'metadata';
        }
      };
      $scope.pageChanged(1);
      $scope.close = close;
      $scope.selectDocument = function (document) {
        if (AttachmentDocumentService.findDuplicate(config.references, document) > -1) {
          $scope.warnOnDuplicateReferences = true;
        } else {
          return $scope.close({
            id: document.documentId, name: document.name
          });
        }
      };
      $scope.uploadAndAttach = function () {
        $scope.uploadState = 'attaching';
        AttachmentDocumentService.uploadFile($scope.flowConfiguration.flow.files[0].file,
          $scope.documentData.documentName, $scope.documentData.fileName,
          $scope.documentData.comment, moment($scope.documentData.documentDate).valueOf(),
          $scope.documentData.documentStatus, $scope.documentData.documentLabel,
          (document) => {
            $scope.close({
              id: document.documentId, name: document.name
            });
          });
      };
    }]);
